
import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-bulk-toast',
    template: `
    <p-toast position="bottom-left" key="bulkAction" styleClass="bulk-toast">
      <ng-template let-message pTemplate="message">
        <div class="flex">
          <i class="pi pi-exclamation-triangle bulk-toast-icon"></i>
          <div class="mx-4 bulk-toast-message">
            <div class="pb-2 bulk-toast-summary">{{ message.summary }}</div>
            @for (item of message.data; track item) {
              <p class="mb-1">{{ item }}</p>
            }
          </div>
        </div>
      </ng-template>
    </p-toast>
    `,
    imports: [
    ToastModule
],
    providers: [
        MessageService
    ]
})
export class BulkToastComponent { }
